import { skipEmpty } from "./_helpers";

/**
 * Creates Inversed Predicate
 *
 * @typedef {import("./types").Predicate} Predicate
 * @type {(predicate: Predicate): Predicate}
 */
export const not = predicate => (...args) => !predicate(...args);

const and2 = skipEmpty(
	// decoratorating with "skipEmpty"
	(pred1, pred2) => (...args) => pred1(...args) && pred2(...args),
);

/**
 * Creates new Predicate that returns true if all of argument predicates return true
 *
 * @typedef {import("./types").Predicate} Predicate
 * @type {(...predicates: Predicate[]): Predicate}
 */
export const and = (...predicates) => predicates.reduce(and2);

const or2 = skipEmpty(
	// decoratorating with "skipEmpty"
	(pred1, pred2) => (...args) => pred1(...args) || pred2(...args),
);

/**
 * Creates new Predicate that returns true if at least one of argument predicates return true
 *
 * @typedef {import("./types").Predicate} Predicate
 * @type {(...predicates: Predicate[]): Predicate}
 */
export const or = (...predicates) => predicates.reduce(or2);
